
import TiwiMixin from '../mixins/TiwiMixin';

export default {
  mixins: [TiwiMixin]
}
